import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const logoSrc = `${process.env.PUBLIC_URL || ''}/images/ubitz-logo.webp`;

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-400 ${
      isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg border-b border-gray-200' : 'bg-white/80 backdrop-blur-sm'
    }`}>
      <div className="max-w-[1400px] mx-auto px-[7.6923%] py-4 flex items-center justify-between">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
          <img 
            src={logoSrc} 
            alt="Ubitz Logo" 
            className="h-16"
            width="220"
            height="64"
            loading="eager"
            decoding="async"
            fetchPriority="high"
          />
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8">
          <button onClick={() => scrollToSection('about')} className="nav-link">About</button>
          <button onClick={() => scrollToSection('services')} className="nav-link">Services</button>
          <button onClick={() => scrollToSection('peopleverse')} className="nav-link">PeopleVerse</button>
          <button onClick={() => scrollToSection('knowledge')} className="nav-link">Knowledge</button>
          <button onClick={() => scrollToSection('contact')} className="btn-primary-nav">Get Started</button>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-gray-700"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="flex flex-col gap-4 p-6">
            <button onClick={() => scrollToSection('about')} className="nav-link-mobile">About</button>
            <button onClick={() => scrollToSection('services')} className="nav-link-mobile">Services</button>
            <button onClick={() => scrollToSection('peopleverse')} className="nav-link-mobile">PeopleVerse</button>
            <button onClick={() => scrollToSection('knowledge')} className="nav-link-mobile">Knowledge</button>
            <button onClick={() => scrollToSection('contact')} className="btn-primary-nav w-full">Get Started</button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;